import { styled } from '@mui/material/styles'
import SnackbarContent from '@mui/material/SnackbarContent'
import green from '@mui/material/colors/green'
import amber from '@mui/material/colors/amber'
const PREFIX = 'Message'

export const classes = {
  success: `${PREFIX}-success`,
  error: `${PREFIX}-error`,
  info: `${PREFIX}-info`,
  warning: `${PREFIX}-warning`,
  icon: `${PREFIX}-icon`,
  iconVariant: `${PREFIX}-iconVariant`,
  message: `${PREFIX}-message`,
}

const StyledSnackbarContent = styled(SnackbarContent)(({ theme }) => ({
  [`&.${classes.success}`]: {
    backgroundColor: green[600],
  },

  [`&.${classes.error}`]: {
    backgroundColor: theme.palette.error.main,
  },

  [`&.${classes.info}`]: {
    backgroundColor: theme.palette.primary.main,
  },

  [`&.${classes.warning}`]: {
    backgroundColor: amber[700],
  },

  [`& .${classes.icon}`]: {
    fontSize: 20,
  },

  [`& .${classes.iconVariant}`]: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },

  [`& .${classes.message}`]: {
    display: 'flex',
    alignItems: 'center',
  },
}))

export default StyledSnackbarContent
